import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { TemplatesModalV2 } from './TemplatesModalV2'
import { useRootStore } from 'stores/RootStore'
import { TemplatesModalV2Props } from './Types'

interface TemplatesDrawerV2Props extends TemplatesModalV2Props, DrawerProps {}

export const TemplatesDrawerV2 = observer((props: TemplatesDrawerV2Props) => {
  const { closeDrawer } = useRootStore().drawersStore

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <Drawer.InnerContent isSnappedTop>
            <Drawer.Container padding="0px">
              <TemplatesModalV2 onClose={closeDrawer} {...props} />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
